import { Card, CardBody, Alert, Button } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';
import { useBrand } from '../brand/BrandProvider';
import { useMe } from '../me/MeProvider';

/**
 * Sichtbarer Bootstrap-Fehler statt stillem Redirect-Loop.
 *
 * Wird gerendert wenn nach Login der Bootstrap-Chain
 * (/brands → /me) ein Fehler passiert. Zeigt aktuellen
 * State + nächste Schritte — kein automatisches Logout.
 */
export function BootstrapError() {
  const auth = useAuth();
  const brand = useBrand();
  const me = useMe();
  const navigate = useNavigate();

  const logout = () => {
    auth.signOut();
    navigate('/login', { replace: true });
  };

  return (
    <div className="d-flex align-items-center justify-content-center vh-100 bg-body-tertiary">
      <Card style={{ maxWidth: 720, width: '100%' }}>
        <CardBody>
          <h3 className="mb-3">🛑 Bootstrap unterbrochen</h3>
          <p className="text-muted">
            Login war erfolgreich, aber die nachfolgende Provider-Chain
            (<code>/v1/operator/brands</code> → <code>/v1/operator/me</code>) konnte
            nicht abgeschlossen werden.
          </p>

          <Alert color="info" className="small">
            <strong>State-Inspector:</strong>
            <ul className="mb-0 mt-2">
              <li>
                <code>auth.status</code> = <code>{auth.status}</code>
                {auth.getAccessToken()
                  ? ` · accessToken: ••••${auth.getAccessToken().slice(-8)}`
                  : ' · accessToken: nicht gesetzt'}
              </li>
              <li>
                <code>brand.status</code> = <code>{brand.status}</code>
                {' · brands.length = '}{brand.brands.length}
                {brand.currentBrandOrigin && (
                  <> · currentBrandOrigin: <code>{brand.currentBrandOrigin}</code></>
                )}
              </li>
              <li>
                <code>me.status</code> = <code>{me.status}</code>
              </li>
            </ul>
          </Alert>

          <Alert color="warning" className="small">
            <strong>Diagnose-Schritte:</strong>
            <ol className="mb-0 mt-2">
              <li>DevTools → <strong>Console</strong>: nach <code>[orbit:</code>-Log-Einträgen suchen</li>
              <li>DevTools → <strong>Network</strong>: zuletzt fehlgeschlagener Call ansehen
                (Status + Response-JSON)
              </li>
              <li>Wenn <code>missing_brand_origin</code> oder <code>tenant_not_in_membership</code>:
                falsche Brand im Default — andere <code>VITE_DEFAULT_BRAND_ORIGIN</code> setzen
              </li>
              <li>Wenn <code>invalid_token</code>: Response-Shape vom Login/MFA-Verify
                hat nicht die erwarteten Token-Felder (siehe Console-Log
                <code>[orbit:login]</code> oder <code>[orbit:mfa-verify]</code>)
              </li>
            </ol>
          </Alert>

          <div className="d-flex gap-2">
            <Button color="primary" outline onClick={() => navigate(0)}>
              ↻ Reload
            </Button>
            <Button color="secondary" outline onClick={logout}>
              Abmelden + neu einloggen
            </Button>
          </div>
        </CardBody>
      </Card>
    </div>
  );
}
